export var removePriceList = [
    {
        key: "productPrice",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "discount",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "discountPrice",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "optionsMstVat",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "valueExTax",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "vat",
        remove: true,
        render: function() {
            return null;
        }
    },
    {
        key: "valueIncludingTax",
        remove: true,
        render: function() {
            return null;
        }
    }
];
